// compressorJs config for image
const STRICT = true;
const CHECKORIENTATION = false;
const MAXWIDTH = 1920;
const MAXHEIGHT = 1920;
const MINWIDTH = 0;
const MINHEIGHT = 0;
const WIDTH = undefined;
const HEIGHT = undefined;
const QUALITY = 0.8;
const MIMETYPE = '';
const CONVERTSIZE = 1000000;
// on file click
const ANIMATION_DURATION_300MS = 300;

//all files max limit
const MAX_FILE_SIZE = 15123123; //15mb

export default {
    STRICT,
    CHECKORIENTATION,
    MAXWIDTH,
    MAXHEIGHT,
    MINWIDTH,
    MINHEIGHT,
    WIDTH,
    HEIGHT,
    QUALITY,
    MIMETYPE,
    CONVERTSIZE,
    ANIMATION_DURATION_300MS,
    MAX_FILE_SIZE,
};
